import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../components/button/Button';
import ExternalLinkWrapper from '../navigation/ExternalLinkWrapper';
import { generateReactKey } from '../../utils/shared/commonUtils';
import {
    HELP_ITEMS_DEMO,
    PDF_STATIC_DEMO_MAPPER,
    DEMO_PDF,
} from '../../constants/reading/DemoModeConstants';
import {
    CLASS_SUMMARY_PDF,
    CURRENT_PAGE,
    ALL_PM_GRAPHS_PDF,
    ALL_STUDENT_SUMMARY_PDF,
} from '../../constants/shared/PdfGenerationConstants';

const TopMenuNavigationDropDown = ({
    title,
    alignment,
    items,
    isDisabled,
    isDemoModeOn,
    downloadDemoPdf,
    selectedPeriod,
    demoClass,
    isGuidedTourOn,
}) => {
    const [isExpanded, setExpanded] = useState(false);

    const toggleDropDown = () => {
        if (!isDisabled) {
            setExpanded(!isExpanded);
        }
    };

    const onBlurDropDown = ({ currentTarget }) => {
        // onBlur should be triggered after onClick
        setTimeout(() => {
            if (!currentTarget.contains(document.activeElement)) {
                setExpanded(false);
            }
        }, 0);
    };

    const inDemoOnClick = item => {
        if (isGuidedTourOn) return () => {};
        if (item.title === CURRENT_PAGE) {
            return item.onClick;
        }
        if (item.id === CLASS_SUMMARY_PDF) {
            const fileName = `${item.id}-${selectedPeriod} - ${DEMO_PDF}`;
            const url = PDF_STATIC_DEMO_MAPPER[demoClass][item.id][selectedPeriod];
            return () => downloadDemoPdf(url, fileName);
        }
        if (item.id === ALL_STUDENT_SUMMARY_PDF || item.id === ALL_PM_GRAPHS_PDF) {
            const fileName = `${item.id} - ${DEMO_PDF}`;
            const url = PDF_STATIC_DEMO_MAPPER[demoClass][item.id];
            return () => downloadDemoPdf(url, fileName);
        }
        return null;
    };

    const inDemoUrlPaths = item => (HELP_ITEMS_DEMO.includes(item.title) ? item.url : null);

    return (
        <li
            className={`nav-item dropdown ${isExpanded ? 'show' : ''}`}
            onClick={toggleDropDown}
            onBlur={e => onBlurDropDown(e)}
            tabIndex={-1}
        >
            <Button
                id={`${alignment}-menu`}
                text={title}
                data-tour-allow-interaction={false}
                className={`nav-item-btn ${isDisabled ? 'disabled' : ''}`}
            />
            <div
                className={`dropdown-menu nav-dropdown dropdown-menu-${alignment} ${
                    isExpanded ? 'show' : ''
                }`}
                aria-labelledby={`${alignment}-menu`}
            >
                {items.map(item => {
                    return (
                        <ExternalLinkWrapper
                            key={generateReactKey(item.id || item.title)}
                            className="dropdown-item"
                            path={isDemoModeOn ? inDemoUrlPaths(item) : item.url}
                            content={item.title}
                            onClick={isDemoModeOn ? inDemoOnClick(item) : item.onClick}
                        />
                    );
                })}
            </div>
            <div className="nav-arrow" />
        </li>
    );
};

TopMenuNavigationDropDown.defaultProps = {
    title: '',
    alignment: 'left',
    items: [],
    isDisabled: false,
    isDemoModeOn: false,
    downloadDemoPdf: () => {},
    selectedPeriod: '',
    demoClass: '',
    isGuidedTourOn: false,
};

TopMenuNavigationDropDown.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    alignment: PropTypes.string,
    items: PropTypes.any,
    isDisabled: PropTypes.bool,
    isDemoModeOn: PropTypes.bool,
    downloadDemoPdf: PropTypes.func,
    selectedPeriod: PropTypes.string,
    demoClass: PropTypes.string,
    isGuidedTourOn: PropTypes.bool,
};

export default TopMenuNavigationDropDown;
